import { $color } from "@/utils/cssVarUtils";
import { formErrorAnatomy as parts } from "@chakra-ui/anatomy"
import { SystemStyleObject } from "@chakra-ui/react";
import type {
  PartsStyleObject,
} from "@chakra-ui/theme-tools"

const baseStyleText: SystemStyleObject = {
  fontSize: 'xs',
  color: $color('danger-normal'),
}

const baseStyleIcon: SystemStyleObject = {
  color: $color('danger-normal'),
}

const baseStyle: PartsStyleObject<typeof parts> = {
  text: baseStyleText,
  icon: baseStyleIcon,
}

export const FormError = {
  parts: parts.keys,
  baseStyle,
}